(function() {
    'use strict';

    angular
        .module('app.perfilesAsiento')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/perfiles-asiento',
                config: {
                    templateUrl: 'app/perfilesAsiento/perfilesAsiento.html',
                    controller: 'PerfilesAsiento',
                    controllerAs: 'vm',
                    title: 'PerfilesAsiento'
                }
            },
            {
                url: '/editar-perfil-asiento/:id?',
                config: {
                    templateUrl: 'app/perfilesAsiento/editarPerfilAsiento.html',
                    controller: 'EditarPerfilAsiento',
                    controllerAs: 'vm',
                    title: 'EditarPerfilAsiento'
                }
            }
        ];
    }
})();
